import api from '@/api/index.js'

const audit_log_resources = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_AUDIT_LOG_RESOURCES_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_AUDIT_LOG_RESOURCES: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_AUDIT_LOG_RESOURCES_ERROR: (state, error) => {
      state.error = error
    }
  },

  actions: {
    LoadAuditLogResources({commit}) {
      commit('SET_AUDIT_LOG_RESOURCES_ERROR', null)
      commit('SET_AUDIT_LOG_RESOURCES_LOADING', true)
      return api.get(`audit-log-resource-kinds`)
        .then((response) => {
          commit('SET_AUDIT_LOG_RESOURCES', response)
        })
        .catch((error) => {
          commit('SET_AUDIT_LOG_RESOURCES_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_AUDIT_LOG_RESOURCES_LOADING', false)
        })
    }
  }
}

export default audit_log_resources
